import React, { useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Loader from '../../components/Loader'

const SquareCallback = () => {
	const navigate = useNavigate()

	const userLogin = useSelector((state) => state.userLogin)
	const { userInfo } = userLogin

	const callCallBack = async (code, config) => {
		const url = process.env.REACT_APP_API_URL
		await axios
			.get(
				`${url}/api/square/oauth/callback/?code=${code}`,
				config
			)
			.then((response) => {
				console.log('Successfully authenticated with Square:', response.data)
				navigate('/dashboard/')
			})
			.catch((error) => {
				alert('Error: ' + (error.response?.data?.error || error.message))
				console.error('Error during Square authentication:', error)
				navigate('/dashboard/')
			})
	}

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search)
		const code = urlParams.get('code')
		const error = urlParams.get('error')
		const success = urlParams.get('success')
		const merchant_id = urlParams.get('merchant_id')

		// If redirected from backend with success, just show message and redirect to dashboard
		if (success) {
			alert('Square account connected successfully!')
			navigate('/dashboard/')
			return
		}

		let config

		if (userInfo) {
			config = {
				headers: {
					'Content-type': 'application/json',
					Authorization: `Bearer ${userInfo.access}`,
				},
			}
		}

		if (error) {
			console.error('OAuth error:', error)
			alert('Square OAuth error: ' + error)
			navigate('/dashboard/')
		} else if (code) {
			// If user is not logged in, the backend will handle it and redirect here
			// We'll just show a message and redirect to login
			if (!userInfo) {
				alert('Please log in first before connecting your Square account.')
				navigate('/')
				return
			}
			callCallBack(code, config)
		} else {
			// No code and no success - might have come from backend redirect
			console.log('No authorization code found. If you just connected Square, check your merchants page.')
			navigate('/dashboard/')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [navigate])

	return (
		<div>
			<Loader />
		</div>
	)
}

export default SquareCallback

